// Environment-based configuration
const isDevelopment = process.env.NODE_ENV === 'development';

// Get API URL from environment variables with fallbacks
const getApiUrl = () => {
  // First priority: explicit REACT_APP_API_URL
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Second priority: construct from REACT_APP_API_PORT
  if (process.env.REACT_APP_API_PORT) {
    return `http://localhost:${process.env.REACT_APP_API_PORT}/`;
  }
  
  // Environment-based fallbacks
  if (isDevelopment) {
    return 'http://localhost:3001/'; // Default dev port
  }
  
  return 'https://trackable-gpt-backend.onrender.com/'; // Default production
};

// Available backend URLs for debugging/switching
export const BACKEND_URLS = {
  LOCALHOST_3001: 'http://localhost:3001/',
  LOCALHOST_3000: 'http://localhost:3000/',
  LOCALHOST_5000: 'http://localhost:5000/',
  LOCALHOST_8000: 'http://localhost:8000/',
  PRODUCTION: 'https://trackable-gpt-backend.onrender.com/',
  STAGING: 'https://trackable-gpt-backend-staging.onrender.com/'
};

// Default BASE_URL based on environment and configuration
export const DEFAULT_BASE_URL = getApiUrl();

// Development logging
if (isDevelopment) {
  console.log('🌐 API Configuration:', {
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    REACT_APP_API_PORT: process.env.REACT_APP_API_PORT,
    DEFAULT_BASE_URL,
    availableUrls: Object.keys(BACKEND_URLS)
  });
}

// This will be the active BASE_URL (can be changed via debug tools)
export let BASE_URL = DEFAULT_BASE_URL;

// Docker service URL (separate microservice, always production)
export const DOCKER_SUMMARY_URL = 'https://trackable-gpt-backend-docker.onrender.com/';

// Function to update BASE_URL at runtime (for debug tools)
export const setBaseUrl = (newUrl) => {
  BASE_URL = newUrl;
  console.log('🔧 BASE_URL changed to:', BASE_URL);
};

// Convenience function to switch to a different localhost port
export const switchToPort = (port) => {
  const newUrl = `http://localhost:${port}/`;
  setBaseUrl(newUrl);
  return newUrl;
};

// Convenience functions for common ports
export const switchToCommonPorts = {
  backend: () => switchToPort(3001),
  frontend: () => switchToPort(3000),
  express: () => switchToPort(5000),
  django: () => switchToPort(8000),
  rails: () => switchToPort(3000),
  flask: () => switchToPort(5000)
};

export const ENDPOINTS = {
  SIGNUP: 'auth/signup',
  LOGIN: 'auth/login',
  GOOGLE_LOGIN: 'auth/googleLogin',
  UPDATE_PROFILE: 'users/profile',
  DELETE_ACCOUNT: 'users/account',
  CREATE_LINK: 'links',
  LINK_STATUS: 'links/status',
  SUMMARY: 'summarize/summary', 
  LOG_CLICK: 'links/clicks',
  SUMMARY_CLICK: 'links/summary-clicks',
  LINK_ANALYTICS: 'analytics/links',
  ANALYTICS: 'analytics', // Base analytics endpoint
  STIPE_PAYMENT_INTENT: 'billing/payments/intent', // One-time payments
  SUBSCRIPTION_CREATE: 'billing/subscriptions', // Recurring subscriptions
  CHECKOUT_SESSION: 'billing/checkout/session', // Stripe Checkout for subscriptions
  PAYMENT_PLANS: 'billing/plans',
  BILLING_PORTAL: 'billing/portal', // Stripe customer portal
  SUBSCRIPTION_STATUS: 'billing/subscription/status',
  SUBSCRIPTION_DETAILS: 'billing/subscription/details',
  SUBSCRIPTION_SYNC: 'billing/subscription/sync', // Force sync from Stripe
};
